module.exports = __webpack_public_path__ + "img/toutu_ETCgognenngshiyongzhinan@1x.69081c33.png";